import React, { useState } from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const [showAll, setShowAll] = useState(false);
  const testimonials = [{
    name: 'Carmen R.',
    age: 43,
    city: 'Valencia',
    quote: 'Llevaba 3 años con el vientre hinchado cada tarde. Pensé que era normal a mis 43 años. En el día 6 del protocolo ya notaba la diferencia. En el día 14 bajé 4 centímetros de vientre y por fin tengo energía para llegar a la noche.',
    initials: 'CR',
    color: 'bg-emerald-700'
  }, {
    name: 'Lucía M.',
    age: 51,
    city: 'Madrid',
    quote: 'Lo compré sin creerme demasiado. 26 euros no te arruinan y la garantía me daba seguridad. Para el día 10 mi marido me preguntó qué había hecho diferente. Me sentía yo misma por primera vez en años.',
    initials: 'LM',
    color: 'bg-blue-700'
  }, {
    name: 'Ana B.',
    age: 38,
    city: 'Barcelona',
    quote: 'Probé mil cosas antes de esto. La diferencia es que aquí entiendes POR QUÉ haces cada cosa. No es seguir una lista — es entender tu propio cuerpo. Eso lo cambia todo.',
    initials: 'AB',
    color: 'bg-purple-700'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-352">
      <div className="max-w-6xl mx-auto" data-id="element-353">
        <div className="text-center mb-16" data-id="element-354">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-brand-dark" data-id="element-355">
            Lo que dicen las mujeres que ya lo han hecho
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-356">
          {testimonials.map((t, i) => <div key={i} className={`bg-brand-cream p-8 rounded-2xl border border-brand-gold/20 shadow-sm flex flex-col h-full ${!showAll && i > 0 ? 'hidden md:flex' : 'flex'}`} data-id="element-357">
              <div className="flex items-center mb-6" data-id="element-358">
                <div className={`w-14 h-14 rounded-full ${t.color} text-white flex items-center justify-center text-xl font-bold mr-4`} data-id="element-359">
                  {t.initials}
                </div>
                <div data-id="element-360">
                  <h4 className="font-bold text-brand-dark text-lg" data-id="element-361">
                    {t.name}
                  </h4>
                  <p className="text-brand-gray text-sm" data-id="element-362">
                    {t.age} años, {t.city}
                  </p>
                </div>
              </div>
              <div className="flex mb-4" data-id="element-363">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-364" />)}
              </div>
              <p className="text-brand-dark text-[17px] italic leading-relaxed flex-grow" data-id="element-365">
                "
                {t.quote.split(/(bajé 4 centímetros de vientre|Me sentía yo misma por primera vez en años|entiendes POR QUÉ haces cada cosa)/).map((part, idx) => {
              if (part === 'bajé 4 centímetros de vientre' || part === 'Me sentía yo misma por primera vez en años' || part === 'entiendes POR QUÉ haces cada cosa') {
                return <strong key={idx} className="font-bold underline decoration-brand-gold decoration-2 underline-offset-2" data-id="element-366">
                          {part}
                        </strong>;
              }
              return part;
            })}
                "
              </p>
            </div>)}
        </div>

        {!showAll && <div className="text-center md:hidden mb-12" data-id="element-367">
            <button onClick={() => setShowAll(true)} className="bg-white border-2 border-brand-dark text-brand-dark font-bold py-3 px-8 rounded-full" data-id="element-368">
              Ver más opiniones
            </button>
          </div>}

        <div className="text-center" data-id="element-369">
          <div className="inline-block bg-brand-dark text-white px-8 py-4 rounded-full shadow-md border border-brand-gold/30" data-id="element-370">
            <p className="text-lg sm:text-xl font-medium" data-id="element-371">
              Más de{' '}
              <strong className="text-brand-gold font-bold text-2xl" data-id="element-372">
                1.847
              </strong>{' '}
              mujeres ya han iniciado su Reinicio Biológico este año
            </p>
          </div>
        </div>
      </div>
    </section>;
}